import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

function OverviewDataCards({ overviewDetails }) {
  return (
    <Row className="mb-4">
      {overviewDetails.map((item, index) => (
        <Col md={6} lg={6} xl={4} key={index}>
          <Card className="p-3 h-100 overview-card" style={{ border: '2px solid #ECEEF5' }}>
            <div className="d-flex align-items-center">
              <div className="icon-container me-3">
                <img src={item.icon} alt={item.label} width={50} />
              </div>
              <div>
                <h5 className="value">{item.value}</h5>
                <p className="label">{item.label}</p>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default OverviewDataCards;